// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_GC_","cls2":"CoauthorConfirmationCard-cls2__R_ CoauthorConfirmationCard-cls1_GC_"};